import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { Option } from '../../types/option'

import * as S from './styles'
import { Controller, useFormContext } from 'react-hook-form'
import { MedicalRecordFormData } from '../../medicalRecordSchema'
import { CustomRadioButton } from '../CustomRadioButton'
import { RadioButtonErrorWrapper } from '../RadioButtonErrorWrapper'

const radioOptions: Option[] = [
  { id: 'suicidal-ideation-yes', name: 'Sim' },
  { id: 'suicidal-ideation-no', name: 'Não' },
]

export function SuicidalIdeation(): JSX.Element {
  const {
    control,
    formState: { errors },
  } = useFormContext<MedicalRecordFormData>()

  const errorMessage = errors.has_suicidal_ideation?.message

  return (
    <S.SuicidalIdeationContainer>
      <Typography weight='bolder' variant='content2'>
        Paciente possui ideação suicida? *
      </Typography>
      <RadioButtonErrorWrapper errorMessage={errorMessage}>
        <S.RadioButtonOptions>
          {radioOptions.map((option) => (
            <Controller
              key={option.id}
              control={control}
              name='has_suicidal_ideation'
              render={({ field }) => (
                <CustomRadioButton
                  {...field}
                  key={option.id}
                  id={option.id as string}
                  onChange={() => field.onChange(option.id)}
                  label={
                    <Typography variant='content2'>{option.name}</Typography>
                  }
                  hasError={!!errorMessage}
                />
              )}
            />
          ))}
        </S.RadioButtonOptions>
      </RadioButtonErrorWrapper>
    </S.SuicidalIdeationContainer>
  )
}
